import React, { Component } from "react"
import { text, options, formulas } from "../../attributes/items/primitives"
import { Heading } from "ui"
import ContentEditable from "react-sane-contenteditable"
import { ATTR_NAME } from "../../BlockVisibility"

/**
 * @augments {Component<BlockTypeProps<{text: string}>, any>}
 */
export default class HeadingBlockType extends Component {
    state = { edits: { edit: null, callback: null } }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle, evaluateFormulas, updateAttributes, selected }) => (
                    <ContentEditable
                        tagName={makeCurriedComponent(Heading, {
                            size: attrs.size,
                        })}
                        style={{ ...computedStyle, margin: 0, height: "100%", width: "100%" }}
                        content={
                            selected
                                ? this.state.edit || attrs.text
                                : evaluateFormulas(this.state.edit || attrs.text)
                        }
                        editable={selected}
                        multiLine={false}
                        styled
                        onChange={(_, value) =>
                            this.saveEditsUntilUnselected(value, updateAttributes)
                        }
                    />
                )}
            </Wrapper>
        )
    }

    saveEditsUntilUnselected(edit, callback) {
        // Mutate directly so we don't update
        this.state.edits.edit = edit
        this.state.edits.callback = callback
    }

    componentWillUpdate() {
        if (this.state.edits.edit) {
            this.state.edits.callback("text", lineBreakToBr(this.state.edits.edit))
            this.state.edits = { edit: null, callback: null }
        }
    }
}

HeadingBlockType.attributes = [
    text({ field: "text", label: "Text" }),
    options({
        field: "size",
        label: "Size",
        options: [
            { label: "Small", value: "small" },
            { label: "Medium", value: "medium" },
            { label: "Large", value: "large" },
        ],
    }),
]

const makeCurriedComponent = (Component, defaultProps) => props => (
    <Component {...defaultProps} {...props} />
)

const lineBreakToBr = text => text.replace("\n", "<br>")



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/basic/HeadingBlock.js